import { render } from "./ExamQuestionItem.vue?vue&type=template&id=2ec1f730&scoped=true"
import script from "./ExamQuestionItem.vue?vue&type=script&lang=js"
export * from "./ExamQuestionItem.vue?vue&type=script&lang=js"

import "./ExamQuestionItem.vue?vue&type=style&index=0&id=2ec1f730&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec1f730"]])

export default __exports__